// Mock data for the website

export const testimonials = [
  {
    id: 1,
    name: "Sarah Mitchell",
    designation: "CEO, TechStart Innovations",
    text: "The team made trademark registration seamless. Their expertise saved us months of uncertainty. Highly recommended for any startup looking to protect their brand.",
    rating: 5
  },
  {
    id: 2,
    name: "David Chen",
    designation: "Founder, Urban Brew Coffee",
    text: "Outstanding service from start to finish. They handled everything professionally and kept us informed throughout the entire process. Worth every penny.",
    rating: 5
  },
  {
    id: 3,
    name: "Jennifer Rodriguez",
    designation: "Creative Director, Elegant Designs Studio",
    text: "I was nervous about the trademark process, but they made it easy to understand. Their comprehensive search saved me from potential conflicts.",
    rating: 5
  },
  {
    id: 4,
    name: "Michael Thompson",
    designation: "Managing Partner, Summit Legal Solutions",
    text: "Professional, efficient, and knowledgeable. They guided us through complex trademark issues with expertise and patience. Exceptional service.",
    rating: 5
  },
  {
    id: 5,
    name: "Emily Watson",
    designation: "Owner, Fresh Market Organics",
    text: "The deluxe package was perfect for our needs. Having a dedicated case manager made all the difference. Our brand is now fully protected.",
    rating: 5
  },
  {
    id: 6,
    name: "Robert Anderson",
    designation: "VP of Operations, GlobalTech Solutions",
    text: "Their trademark monitoring service caught a potential infringement early. The team's proactive approach has been invaluable to our brand protection strategy.",
    rating: 5
  },
  {
    id: 7,
    name: "Lisa Patel",
    designation: "Marketing Director, StyleHub Fashion",
    text: "Filing trademarks for our fashion line was stress-free thanks to their guidance. They understood our industry needs and delivered exceptional results.",
    rating: 5
  },
  {
    id: 8,
    name: "James Wilson",
    designation: "Co-Founder, Wellness Plus",
    text: "From consultation to approval, the entire journey was smooth. Their expertise in health and wellness trademarks gave us confidence in our brand protection.",
    rating: 5
  },
  {
    id: 9,
    name: "Amanda Foster",
    designation: "Brand Manager, EcoLiving Products",
    text: "We've worked with several trademark services, but this team stands out for their attention to detail and personalized approach. Absolutely fantastic!",
    rating: 5
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: "Essentials",
    price: "$45",
    federal: "+ Federal Filing Fee",
    features: [
      "Case Review",
      "Case Filing",
      "Basic Search",
      "State E-Filing",
      "Trademark Secured"
    ],
    // note: "Govt. filing fee not included",
    recommended: false
  },
  {
    id: 2,
    name: "Enhanced",
    price: "$149",
    federal: "+ Federal Filing Fee",
    features: [
      "Case Review",
      "Case Filing",
      "Direct Hit Search",
      "Trademark Alert",
      "Trademark Secured",
      "High Satisfaction Rate",
      "Refusal Risk Meter"
    ],
    // note: "Govt. filing fee not included",
    recommended: false
  },
  {
    id: 3,
    name: "Deluxe",
    price: "$299",
    federal: "+ Federal Filing Fee",
    features: [
      "Case Review",
      "Case Filing",
      "Direct Hit Search",
      "Trademark Alert",
      "Trademark Secured",
      "High Satisfaction Rate",
      "Refusal Risk Meter",
      "Trademark Monitoring",
      "Complete Documentation",
      "Digital File",
      "Dedicated Case Manager"
    ],
    // note: "Govt. filing fee not included",
    recommended: true
  },
  {
    id: 4,
    name: "Platinum",
    price: "$349",
    federal: "+ Federal Filing Fee",
    features: [
      "Case Review",
      "Case Filing",
      "Direct Hit Search",
      "Trademark Alert",
      "Trademark Secured",
      "High Satisfaction Rate",
      "Refusal Risk Meter",
      "Trademark Monitoring",
      "Complete Documentation",
      "Digital File",
      "Dedicated Case Manager",
      "High Approval Rate",
      "Comprehensive Search Report",
      "High Priority Service",
      "Cease & Desist Letter"
    ],
    // note: "Govt. filing fee not included",
    recommended: false
  }
];

export const processSteps = [
  {
    id: 1,
    title: "Comprehensive Search",
    description: "Our team performs an extensive search to identify potential conflicts and assess the viability of your trademark application.",
    icon: "Search"
  },
  {
    id: 2,
    title: "Application Filing",
    description: "We prepare and file your trademark application with the USPTO, ensuring all documentation is accurate and complete.",
    icon: "FileText"
  },
  {
    id: 3,
    title: "Monitoring & Protection",
    description: "After approval, we monitor your trademark and provide ongoing support to maintain and protect your brand rights.",
    icon: "Shield"
  }
];

export const countryCodes = [
  { code: "+1", country: "USA/Canada" },
  { code: "+44", country: "UK" },
  { code: "+91", country: "India" },
  { code: "+61", country: "Australia" },
  { code: "+81", country: "Japan" },
  { code: "+86", country: "China" },
  { code: "+49", country: "Germany" },
  { code: "+33", country: "France" },
  { code: "+39", country: "Italy" },
  { code: "+34", country: "Spain" },
  { code: "+52", country: "Mexico" },
  { code: "+55", country: "Brazil" },
  { code: "+7", country: "Russia" },
  { code: "+82", country: "South Korea" },
  { code: "+65", country: "Singapore" },
  { code: "+31", country: "Netherlands" },
  { code: "+46", country: "Sweden" },
  { code: "+47", country: "Norway" },
  { code: "+41", country: "Switzerland" },
  { code: "+43", country: "Austria" },
  { code: "+32", country: "Belgium" },
  { code: "+45", country: "Denmark" },
  { code: "+358", country: "Finland" },
  { code: "+353", country: "Ireland" },
  { code: "+48", country: "Poland" },
  { code: "+351", country: "Portugal" },
  { code: "+30", country: "Greece" },
  { code: "+420", country: "Czech Republic" },
  { code: "+971", country: "UAE" },
  { code: "+966", country: "Saudi Arabia" },
  { code: "+27", country: "South Africa" },
  { code: "+64", country: "New Zealand" },
  { code: "+62", country: "Indonesia" },
  { code: "+60", country: "Malaysia" },
  { code: "+66", country: "Thailand" },
  { code: "+63", country: "Philippines" },
  { code: "+84", country: "Vietnam" },
  { code: "+20", country: "Egypt" },
  { code: "+234", country: "Nigeria" },
  { code: "+54", country: "Argentina" },
  { code: "+56", country: "Chile" },
  { code: "+57", country: "Colombia" }
];

export const faqs = [
  {
    id: 1,
    question: "How long does the trademark registration process take?",
    answer: "The trademark registration process typically takes 8-12 months from filing to approval. However, this timeline can vary based on the complexity of your application and any potential office actions from the USPTO."
  },
  {
    id: 2,
    question: "What is the difference between state and federal trademark registration?",
    answer: "State trademark registration provides protection only within that specific state, while federal registration through the USPTO offers nationwide protection and additional legal benefits, including the ability to use the ® symbol."
  },
  {
    id: 3,
    question: "Do I need a trademark search before filing?",
    answer: "Yes, a comprehensive trademark search is crucial. It helps identify existing trademarks that might conflict with yours, reducing the risk of rejection and potential legal disputes. Our Enhanced, Deluxe, and Platinum packages include thorough search services."
  },
  {
    id: 4,
    question: "What happens if my trademark application is refused?",
    answer: "If your application receives an office action or refusal, we provide support to respond appropriately. Our higher-tier packages include office action response services and guidance to overcome potential obstacles."
  },
  {
    id: 5,
    question: "How long does trademark protection last?",
    answer: "A registered trademark can last indefinitely as long as you continue to use it in commerce and file the necessary maintenance documents. You must file a Declaration of Use between the 5th and 6th year, and renewal applications every 10 years."
  }
];